import styled from 'styled-components'
import HeaderfulContainer from '../../../../components/molecules/headerfulContainer/index'

export const AdditivesContainer = styled(HeaderfulContainer)``
